export const KEY_ROWS = [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '\''],
  ['Enter', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'Del']
];

